import React from "react";

export default function CviAppShell({ isMobile, header, periodContext, sidebar, bottomNav, children, maxMobileWidth = 420, contentClassName = "", contentStyle = {} }) {
  return (
    <div className="cvi-app-shell" style={{
      maxWidth: isMobile ? maxMobileWidth : "100%",
      margin: isMobile ? "0 auto" : 0,
      border: isMobile ? "1px solid var(--cvi-border,#E8E8EE)" : "none",
      boxShadow: isMobile ? "0 4px 32px rgba(0,0,64,0.08)" : "none",
    }}>
      {header}
      {periodContext}
      <div className="cvi-app-shell-body">
        {!isMobile && sidebar}
        <main className={`cvi-app-shell-content ${contentClassName}`.trim()} style={contentStyle}>
          {children}
        </main>
      </div>
      {isMobile && bottomNav}
    </div>
  );
}
